import type { PaymentDue } from "@fleetlease/shared";
import { useList, money } from "./data";
import { PageHeader, Table } from "./ui";
import { TableSkeleton } from "./ui";
import { Badge } from "./Badge";

const tone = (s: string) => (s === "OVERDUE" ? "danger" : s === "PARTIAL" ? "warn" : "info");

export function Payments() {
  const q = useList<PaymentDue>("payments", "/payments");
  return (
    <div className="space-y-4">
      <PageHeader title="Payments — open dues" />
      {q.isPending ? <TableSkeleton cols={4} /> : (
        <Table<PaymentDue>
          rows={q.data?.items ?? []}
          empty="No open dues. 🎉"
          columns={[
            { header: "Due date", cell: (d) => d.dueDate },
            { header: "Period", cell: (d) => `${d.periodStart} → ${d.periodEnd}` },
            { header: "Amount", cell: (d) => money(d.amountCents) },
            { header: "Status", cell: (d) => <Badge tone={tone(d.status)}>{d.status}</Badge> },
          ]}
        />
      )}
    </div>
  );
}
